"use client";

import { envConfig } from "@/shopify/env-config";
import Script from "next/script";

interface KwikPassScriptProps {
  onLoad: () => void;
}

export default function KwikPassScript({ onLoad }: KwikPassScriptProps) {
  return (
    <>
      <Script id="kwikpass-init">
        {`
        window.merchantInfo = {
          ...window.merchantInfo,
          mid: "${envConfig.gokwik.mid}",
          environment: "${envConfig.gokwik.environment}",
          type: "${envConfig.gokwik.type}",
          integrationType: 'CUSTOM_SHOPIFY'
        };
        `}
      </Script>
      <Script
        id="kwikpass-core"
        src={`${envConfig.gokwik.scriptUrl}/kwikpass/kwikpass-core-functions-min.js`}
      />
      <Script
        id="kwikpass-merchant"
        src={`${envConfig.gokwik.scriptUrl}/kwikpass/plugin/build/kp-merchant-v2.js`}
        strategy="afterInteractive"
        onLoad={onLoad}
      />
    </>
  );
}
